import { Tabs } from "antd";
import styles from './CleanerJobs.module.css';
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import useWindowDimensions from "../../hooks/useWindowDimensions";
import ActiveJobTab from "./ActiveJobTab";
import PastJobTab from "./PastJobTab";

const CleanerJobs = () => {
  const { width, height } = useWindowDimensions();
  const { t, i18n } = useTranslation();
  const [Active, setActive] = useState();
  const [search, setsearch] = useState();
  // const getLanguage = async () => {
  //   try {
  //     const language = localStorage.getItem('@selectedLanguage');
  //     i18n.changeLanguage(language);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  // useEffect(() => {
  //   getLanguage();
  // }, []);
  const items = [
    {
      key: "1",
      label: `${t("Active Job")}`,
      children: <ActiveJobTab />,
    },
    {
      key: "2",
      label: `${t("Past Job")}`,
      children: <PastJobTab />
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t("Jobs")}</h1>
      </div>
      <Tabs
        className="tab_content_styling"
        size="large"
        defaultActiveKey="1"
        items={items}
        tabBarGutter={width > 570 ? 50 : 5}
        // centered
        destroyInactiveTabPane={true}
        onChange={onChange}
        tabBarStyle={
          width > 570
            ? {
              color: "white",
              fontWeight: "bold",
              width: "100%",
              margin: "30px 10px",
            }
            : {
              color: "white",
              fontSize: "8px",
              margin: "10px 0px",
            }
        }
      />
    </div>
  );
};
export default CleanerJobs;
